export const TYPE_COPY = 'COPY';
export const TYPE_DELETE = 'DELETE';
export type ConfirmationType = 'COPY' | 'DELETE' | undefined;

export class TranslatedNotificationMessages {}
